import { keyframes } from '@emotion/css';

export const reducedMotionQuery = '@media (prefers-reduced-motion: reduce)';

export const fadeUpKeyframes = keyframes({
  from: { opacity: 0, transform: 'translateY(6px)' },
  // Ending on "none" rather than translateY(0) keeps the filled final frame from creating a
  // containing block that would trap position: fixed descendants.
  to: { opacity: 1, transform: 'none' },
});

const revealKeyframes = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

export const shimmerKeyframes = keyframes({
  from: { backgroundPosition: '100% 0' },
  to: { backgroundPosition: '-100% 0' },
});

export const motionEasing = {
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  enter: 'cubic-bezier(0.16, 1, 0.3, 1)',
} as const;

export const motionDurations = {
  instant: '120ms',
  quick: '180ms',
  moderate: '240ms',
} as const;

export function createTransition(properties: string[], duration: string = motionDurations.quick): string {
  return properties.map((property) => `${property} ${duration} ${motionEasing.standard}`).join(', ');
}

export const fadeUpEntrance = `${fadeUpKeyframes} ${motionDurations.moderate} ${motionEasing.enter} both`;

// Loads that finish within this delay never show a placeholder, which avoids a skeleton flash on fast
// or cached responses. The placeholder still occupies its space while hidden, so nothing shifts.
const SKELETON_REVEAL_DELAY = '300ms';

export const skeletonReveal = `${revealKeyframes} ${motionDurations.quick} ease-out ${SKELETON_REVEAL_DELAY} both`;

const MAXIMUM_STAGGERED_ITEMS = 10;
const STAGGER_DELAY_MS = 30;

export function staggerDelay(position: number): string {
  return `${Math.min(position, MAXIMUM_STAGGERED_ITEMS) * STAGGER_DELAY_MS}ms`;
}
